import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RightSlideAbsoluteAnimation } from "../../../animations/animations";

import {
  IMAGE_TEMPLATES_INFO,
  VIDEO_TEMPLATES_INFO,
  IMAGE_TEMPLATES,
  VIDEO_TEMPLATES
} from "@talentbait/remotion-templates-talentbait";

import { PosthogStore } from "@talentbait/shared-components";

import { AdAssistantLayout, CartNavigationWrapper, FlexWrapper } from ".././AdAssistant.styled";

import Cart from ".././cart/Cart";
import EditionModal, { orientationsOptions } from ".././edition-modal/EditionModal";

import AdAssistantStore from ".././AdAssistantStore";
import { withRefluxStore } from "../../../Stores";

import { useTranslation } from "react-i18next";
import { ArrowLeftIcon, CreatePostInfoIcon, EditIcon } from "../../../Components/Icons";
import Actions from "../../../Actions";

import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";
import { PlacementsContainer } from "../all-variants-modal/AllVariantsModal.styled";
import { ActionsWrapper, Header, ModalWrapper, Title } from "../edition-modal/EditionModal.styled";
import EditionPreview from "../edition-modal/edition-preview/EditionPreview";
import SaveNavigation from "../save-navigation/SaveNavigation";
import { withRouter } from "react-router-dom";
import {
  AdAssistantOverviewWrapper,
  AdTitleEditWrapper,
  CampaignActive,
  CampaignActiveText,
  EmptyButton,
  PublishButton,
  QuestionsButton
} from "./AdAssistantOverview.styled";
import { useSaveCampaign } from "../hooks/useSaveCampaign";
import PreviewPlacements from "../preview-placements/PreviewPlacements";
import { useAdAssistantDimensions } from "../hooks/useAdAssistantDimensions";
import { useUpdateCombinationData } from "../hooks/useUpdateCombinationData";
import AdAssistantAts from "../qualification-questions/AdAssistantAts";
import { useAdUpdate } from "../hooks/useAdUpdate";
import { useInfiniteScroll } from "../../../hooks/use-infinite-scroll.hook";
import { useSetCampaignLive } from "../hooks/useSetCampaignLive";

export const TEMPLATES = {
  ...IMAGE_TEMPLATES,
  ...VIDEO_TEMPLATES
};

export const TEMPLATE_INFO = {
  ...IMAGE_TEMPLATES_INFO,
  ...VIDEO_TEMPLATES_INFO
};

const VISIBLE_ITEMS = 2;

const AdAssistantOverview = ({
  // Route
  match,
  history,
  // Store
  allAdCombinations,
  usedAds,
  currentAd,
  userProfile,
  isBooked,
  isWaitingForApproval,
  isActive,
  campaignData
}) => {
  const { t } = useTranslation();
  const { campaignId } = match.params;
  const saveCampaign = useSaveCampaign(campaignId);
  const setCampaignLive = useSetCampaignLive(campaignId);
  const dimensions = useAdAssistantDimensions();

  const { visibleItems, loadMoreRef } = useInfiniteScroll({
    scrollContainerId: "scrollable-content",
    initialItems: VISIBLE_ITEMS,
    itemsPerLoad: VISIBLE_ITEMS
  });

  const { updateMediaAssets } = useAdUpdate(currentAd, allAdCombinations, userProfile);

  const [editionModal, setEditionModal] = useState({ isModalOpen: false, type: "" });
  const [atsModal, setAtsModal] = useState(false);
  const [orientationSelected, setOrientationSelected] = useState(orientationsOptions[0]);
  const mediaAssets = currentAd?.mediaAssets;

  const { updateCombinationData } = useUpdateCombinationData({
    currentAd,
    userProfile,
    dimensions,
    allAdCombinations
  });

  const showBackArrow = !isBooked && !isActive;

  const handleOrientationChange = (selectedOrientation) => {
    setOrientationSelected(selectedOrientation);
  };

  const handleEditionModalToggle = ({ type }) => {
    const { isModalOpen } = editionModal;
    const newModalState = !isModalOpen;
    setEditionModal({ isModalOpen: newModalState, type });
    ActionsAdAssistant.setEditModalOpen(newModalState);
  };

  const handleSaveCampaign = async (data) => {
    try {
      const newCampaignData = { ...data, step: "overview" };
      await saveCampaign(newCampaignData);
    } catch (error) {
      Actions.addNotification(t("Saved failed"), "error");
    }
  };

  const handleSetCampaignLive = async () => {
    try {
      await setCampaignLive();
    } catch (error) {
      Actions.addNotification(t("Saved failed"), "error");
    }
  };

  const handleNewInputs = (newInputs) => {
    Actions.addNotification(t("Saved correctly"));
    const newTeaserTextValue = { long: newInputs, short: newInputs };
    const newCampaignData = { defaultText: newTeaserTextValue };

    ActionsAdAssistant.updateAd(
      { updatedBy: userProfile.userName, text: newTeaserTextValue },
      currentAd.id
    );

    const createSuccessfully = ActionsAdAssistant.updateAd.completed.listen((result) => {
      const { payload } = result;

      ActionsAdAssistant.setCurrentAd(payload);

      ActionsAdAssistant.getAdCombinations(campaignId);
      handleSaveCampaign(newCampaignData);
      createSuccessfully();
    });
  };

  const handleNewInputProps = (
    newInputs,
    showNotification,
    orientation = { value: "all", label: "All" }
  ) => {
    const newInputsObject = newInputs.reduce((acc, { key, value }) => {
      acc[key] = value;
      return acc;
    }, {});

    const updateOrientation = (orientationKey) => {
      updatedMediaAssets[orientationKey] = {
        ...mediaAssets[orientationKey],
        inputProps: { ...mediaAssets[orientationKey].inputProps, ...newInputsObject }
      };
    };

    const updatedMediaAssets = { ...mediaAssets };

    if (orientation.value === "all") {
      updateOrientation("vertical");
      updateOrientation("portrait");
      updateOrientation("landscape");
    } else {
      updateOrientation(orientation.value);
    }

    const newMediaAsset =
      orientation.value === "all"
        ? updatedMediaAssets
        : { [orientation.value]: updatedMediaAssets[orientation.value] };

    updateMediaAssets({
      updatedMediaAssets: newMediaAsset,
      showNotification,
      onComplete: (updatedAd) => {
        // Force a refresh of the current ad data
        ActionsAdAssistant.setCurrentAd(updatedAd);
      }
    });
  };

  const handleNewImage = (newImage) => {
    updateCombinationData({ newAsset: newImage });
  };

  const handleEditAd = (ad) => {
    ActionsAdAssistant.updateAd(
      {
        isLocked: true,
        lockedBy: userProfile.userName,
        lockedUserId: userProfile.userId,
        lockedDate: new Date().toISOString()
      },
      ad.id
    );
    ActionsAdAssistant.setCurrentAd(ad);
    handleEditionModalToggle({ type: "image" });
  };

  const handlePublishCampaign = async () => {
    try {
      await handleSetCampaignLive();
      Actions.addNotification(t("Campaign published successfully"));
    } catch (error) {
      Actions.addNotification(t("Failed to publish campaign"), "error");
    }
  };
  // Slice the combinations to show only the visible items
  const visibleCombinations = usedAds.slice(0, visibleItems);

  //Handle visibility of components
  const showEditionModal = editionModal.isModalOpen;
  const showAtsModal = atsModal;
  const showAds = !showAtsModal && !showEditionModal;

  return (
    <AdAssistantLayout>
      <Header>
        <ActionsWrapper>
          {showBackArrow && (
            <EmptyButton onClick={() => history.push(`/assistant/preview/${campaignId}`)}>
              <ArrowLeftIcon />
            </EmptyButton>
          )}
          <Title>Edit Ad</Title>
          <PlacementsContainer bold>
            <span>Campaign</span>
          </PlacementsContainer>
        </ActionsWrapper>
      </Header>
      <ModalWrapper>
        <FlexWrapper gap={11} direction={"column"} align={"flex-start"} width={"max-content"}>
          {showAds && (
            <>
              <PreviewPlacements
                orientationsOptions={orientationsOptions}
                orientationSelected={orientationSelected}
                handleOrientationChange={handleOrientationChange}
              />
              {visibleCombinations.map((ad, index) => {
                return (
                  <AdAssistantOverviewWrapper key={ad.id}>
                    <AdTitleEditWrapper justify="space-between" align="center" width="100%">
                      <span>
                        {`${t("Ad")} ${index + 1}`}
                        {ad.isLocked && ` - Locked by ${ad.lockedBy}`}
                      </span>
                      {!ad.isLocked && (
                        <EmptyButton onClick={() => handleEditAd(ad)}>
                          <EditIcon color="#7A89F4" size={24} strokeWidth={1} />
                        </EmptyButton>
                      )}
                    </AdTitleEditWrapper>

                    <EditionPreview editedAd={ad} orientationSelected={orientationSelected} />
                  </AdAssistantOverviewWrapper>
                );
              })}
            </>
          )}
          <div ref={loadMoreRef} style={{ height: "10px", width: "100%" }} />
        </FlexWrapper>

        <FlexWrapper gap={11} direction={"column"} align={"flex-start"}>
          <CartNavigationWrapper mt="20px">
            {isActive ? (
              <FlexWrapper gap={11} align={"flex-start"} direction={"column"}>
                {isBooked && (
                  <QuestionsButton onClick={() => setAtsModal(!atsModal)}>
                    Edit questions
                  </QuestionsButton>
                )}
                <CampaignActive>
                  <FlexWrapper gap={5} align={"center"}>
                    <CreatePostInfoIcon />
                    {t("Your campaign is already LIVE")}
                  </FlexWrapper>
                  <CampaignActiveText>
                    {t("All done 🙌 Your campaign is already LIVE on all channels.")}
                  </CampaignActiveText>
                </CampaignActive>
              </FlexWrapper>
            ) : (
              <>
                <FlexWrapper gap={11} align={"flex-start"} justify={"flex-start"}>
                  {isBooked && (
                    <QuestionsButton onClick={() => setAtsModal(!atsModal)}>
                      Edit questions
                    </QuestionsButton>
                  )}
                  {isWaitingForApproval && (
                    <PublishButton onClick={handlePublishCampaign}>
                      {t("Approve campaign & start now")}
                    </PublishButton>
                  )}
                </FlexWrapper>
                <Cart selectedItems={usedAds.length} showSelectedBox={false} />
                <SaveNavigation
                  selectedItems={usedAds.length}
                  emitSaveCampaign={(data) => handleSaveCampaign(data)}
                  navigationUrl={`/assistant/budget-check/${campaignId}?budgetCheck=true`}
                  navigationText={"Select channels"}
                />
              </>
            )}
          </CartNavigationWrapper>

          <AnimatePresence>
            {showEditionModal && (
              <EditionModal
                toggleModal={handleEditionModalToggle}
                editionModalType={editionModal.type}
                combinations={allAdCombinations}
                saveNewImage={(imageUrl) => handleNewImage(imageUrl)}
                saveNewData={(newData) => handleNewInputs(newData)}
                saveNewInputProps={(newInputProps, showNotification, orientation) =>
                  handleNewInputProps(newInputProps, showNotification, orientation)
                }
              />
            )}
          </AnimatePresence>

          <AnimatePresence>
            {showAtsModal && (
              <motion.div {...RightSlideAbsoluteAnimation}>
                <AdAssistantAts toggleModal={() => setAtsModal(!atsModal)} />
              </motion.div>
            )}
          </AnimatePresence>
        </FlexWrapper>
      </ModalWrapper>
    </AdAssistantLayout>
  );
};

export default withRouter(
  withRefluxStore(
    AdAssistantOverview,
    [AdAssistantStore, PosthogStore],
    [
      "usedAds",
      "allAdCombinations",
      "currentAd",
      "userProfile",
      "isBooked",
      "isWaitingForApproval",
      "isActive",
      "posthogInstance",
      "campaignData"
    ]
  )
);
